<template>
    <sa-page-layout :showModalLoading="showModalLoading" :btnRefreshVisible="true" @refresh="onRefresh">
        <template slot="toolbar">
            <b-button class="my-2 my-sm-0" variant="outline-purple btn-toolbar sa-margin-left float-sm-left" @click="onClickRendiDisponibiliLetti"> <i class="fas fa-exchange-alt"></i>Rendi Letti Disponibili </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Presidio</label>
                        <b-form-select v-model="filtroGestioneCamere.idPresidio" value-field="value" text-field="text" :options="presidioOptions" :disabled="true">
                            <!--   <template #first>
                                <b-form-select-option :value="null">- Seleziona un presidio - </b-form-select-option>
                            </template> -->
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Piano</label>
                        <b-form-select v-model="filtroGestioneCamere.idPiano" type="search" placeholder="Inserire piano" :options="pianiOptions" @change="onChangePiano">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona piano - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Stanza</label>
                        <b-form-select v-model="filtroGestioneCamere.nomeStanza" type="search" placeholder="Inserire stanza" :options="stanzeOptions" @change="onChangeStanza">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona una stanza - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Tipologia</label>
                        <b-form-select v-model="filtroGestioneCamere.codiceSesso" text-field="descrizione" value-field="codice" type="search" placeholder="Inserire sesso" :options="sessoOptions" @change="onChangeSesso">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona un sesso- </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Stato Letto</label>
                        <b-form-select v-model="filtroGestioneCamere.statoAttuale" text-field="stato" value-field="stato" type="search" placeholder="Inserire sesso" :options="statoLettoOptions">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona Stato Letto -</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Letto</label>
                        <b-form-select v-model="filtroGestioneCamere.nome" type="search" placeholder="Inserire letto" :options="lettoOptions">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona un letto - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" variant="danger" v-on:click="onReset">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>

        <template slot="table-body">
            <b-tabs id="tabsGestioneCamere" ref="tabsGestioneCamere" nav-wrapper-class="sa-tab-items" content-class="" class="sa-tab" fill @input="onChangeTab" v-model="activeTabIndex">
                <b-tab title="Gestione Camere" id="gestioneCamere">
                    <rsa-gestione-camere-list-component ref="cmpGestioneCamereList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-gestione-camere-list-component>
                </b-tab>
                <b-tab title="Storico Letti" id="storicoLetti">
                    <!-- <rsa-storico-letti-list-component ref="cmpStoricoLettiList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" /> -->
                    <rsa-gestione-camere-list-component ref="cmpGestioneStoricoList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-gestione-camere-list-component>
                </b-tab>
            </b-tabs>
        </template>
    </sa-page-layout>
</template>

<script>
import RsaGestioneCamereListComponent from "../components/RsaGestioneCamereListComponent.vue";
// import RsaStoricoLettiListComponent from "../components/RsaStoricoLettiListComponent.vue";
import saPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: { saPageLayout, RsaGestioneCamereListComponent },
    mixins: { UtilityMixin },
    data() {
        return {
            showModalLoading: false,
            pathResourcePresidi: "/strutturepresidi",
            pathResourcePiani: "/rsapostilettopiani",
            pathResourceStanze: "/rsapostilettostanze",
            pathResourceSessi: "/rsapostilettostanzasessi",
            pathResourceStatoLetto: "/rsapostilettolettostati",
            pathResourceLetto: "/rsapostilettoletti",
            pathResourceStato: "/rsapostilettolettostati",
            path: null,
            idPiano: null,
            idStanza: null,
            sesso: null,
            pianiOptions: [],
            stanzeOptions: [],
            lettoOptions: [],
            presidioOptions: [],
            activeTabIndex: 0,
            statoLettoOptions: [],
            sessoOptions: [],
            idPresidio: null,
            filtroGestioneCamere: { idPresidio: null, nomePiano: null, nomeStanza: null, nome: null, codiceSesso: null, statoAttuale: null, idPiano: null },
            filtroGestioneCamereStorico: { idPresidio: null, nomePiano: null, nomeStanza: null, nomeLetto: null, codiceSesso: null, stato: null },
            filtroStanza: { idPiano: null },
            filtroLetto: { idStanza: null },
            filtroPiano: { idPresidio: null },
        };
    },

    mounted() {
        let me = this;
        if (localStorage.getItem("presidio")) {
            me.presidio = localStorage.getItem("presidio") == "null" ? null : JSON.parse(localStorage.getItem("presidio"));
            me.idPresidio = me.presidio ? me.presidio.idPresidio : null;
        }
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroGestioneCamere"]) {
            me.filtroGestioneCamere = JSON.parse(sessionStorage["filtroGestioneCamere"]);
        }
        me.filtroGestioneCamere.idPresidio = me.idPresidio;
        me.loadDataPresidi();
        me.loadDataPiani();
        me.loadDataSesso();
        me.loadDataStatoLetto();
        me.loadData();
        me.filtroStanza = { idPiano: me.filtroGestioneCamere.idPiano };
        if (me.idPresidio) {
            me.onChangePresidi(me.idPresidio);
        }
        me.loadDataStanze();
    },
    /* computed: {
        statoFiltroCorrente: {
            get() {
                return this.activeTabIndex === 0 ? this.filtroGestioneCamere.statoAttuale : this.filtroGestioneCamereStorico.stato;
            },
            set(value) {
                if (this.activeTabIndex === 0) {
                    this.filtroGestioneCamere.statoAttuale = value;
                } else {
                    this.filtroGestioneCamereStorico.stato = value;
                }
            },
        },
    }, */
    //watch: {
    //    filtroGestioneCamere: {
    //        //handler(valueOld, valueNew) {
    //        //    //console.log("filtroGestioneCamere");
    //        //    //console.log(valueOld);
    //        //    //console.log(valueNew);
    //        //},
    //        deep: true,
    //        immediate: true,
    //    },
    //},
    methods: {
        loadData() {
            let me = this;
            me.activeTab(me.path);
        },
        loadDataStatoLetto() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceStatoLetto, null, me.loadDataStatoLettoSuccess, me.loadDataStatoLettoError);
        },
        loadDataStatoLettoSuccess(response) {
            let me = this;
            me.statoLettoOptions = response.data.data.list;
        },
        loadDataStatoLettoError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento stati letto", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataPiani() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourcePiani, me.filtroPiano, me.loadDataPianiSuccess, me.loadDataPianiError);
        },
        loadDataPianiSuccess(response) {
            let me = this;
            if (response.data.data.list) {
                me.pianiOptions = response.data.data.list.map((piano) => ({ value: piano.id, text: piano.nome }));
                //  me.pianiOptions = [];
            }
            if (me.filtroGestioneCamere.nomePiano) {
                let selectedPiano = me.pianiOptions.find((item) => item.value === me.filtroGestioneCamere.nomePiano);
                if (selectedPiano) {
                    me.filtroStanza = { idPiano: selectedPiano.id };
                    me.loadDataStanze();
                }
            }
        },
        loadDataPianiError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei piani", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataSesso() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSessi, null, me.loadDataSessoSuccess, me.loadDataSessoError);
        },
        loadDataSessoSuccess(response) {
            let me = this;
            me.sessoOptions = response.data.data.list;
        },
        loadDataSessoError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei sessi", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataStanze() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceStanze, me.filtroStanza, me.loadDataStanzeSuccess, me.loadDataStanzeError);
        },
        loadDataStanzeSuccess(response) {
            let me = this;
            if (response.data.data.list) {
                me.stanzeOptions = response.data.data.list.map((stanza) => ({
                    value: stanza.nome,
                    text: stanza.nome + " (" + stanza.nomePiano + ")",
                    id: stanza.id,
                }));
            } else {
                me.stanzeOptions = [];
            }
            if (me.filtroGestioneCamere.nomeStanza) {
                let stanzaSelezionata = me.stanzeOptions.find((item) => item.value === me.filtroGestioneCamere.nomeStanza);
                if (stanzaSelezionata) {
                    me.filtroLetto = {
                        idStanza: stanzaSelezionata.id,
                    };
                    me.loadDataLetti();
                }
            }
            //loadDataLetti();
        },
        loadDataStanzeError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento delle stanze", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        loadDataLetti() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceLetto, me.filtroLetto, me.loadDataLettiSuccess, me.loadDataLettiError);
        },
        loadDataLettiSuccess(response) {
            let me = this;
            if (response.data.data.list) {
                me.lettoOptions = response.data.data.list.map((letto) => {
                    return { value: letto.nome, text: letto.nome, id: letto.id };
                });
            } else {
                me.lettoOptions = [];
            }
        },
        loadDataLettiError(response) {
            let me = this;

            me.$bvToast.toast("Errore durante il caricamento dei dati: ", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        onChangePiano(value) {
            let me = this;
            // let selectedPiano = me.pianiOptions.find((piano) => piano.value === nome);
            me.filtroGestioneCamere.nomeStanza = null;
            me.filtroGestioneCamere.nome = null;
            me.stanzeOptions = [];
            me.lettoOptions = [];
            // me.pianiOptions.forEach((element) => {
            //     if (nome === element.nome) {
            //         me.filtro.idPiano = element.id;
            //         selectedPiano= element
            //     }
            // });
            //  if (selectedPiano) {
            me.filtroStanza.idPiano = value;
            me.loadDataStanze();
            me.idPiano = me.filtroStanza.idPiano;
        },
        onChangeStanza(value) {
            let me = this;
            let selectedStanza = me.stanzeOptions.find((stanza) => stanza.value === value);

            me.filtroGestioneCamere.nome = null;
            me.lettoOptions = [];
            if (selectedStanza) {
                me.filtroLetto = { idStanza: selectedStanza.id };
                me.loadDataLetti();
            }
        },
        onChangeSesso(codiceSesso) {
            let me = this;
            let selectedSesso = me.sessoOptions.find((sesso) => sesso.codice === codiceSesso);
            if (selectedSesso) {
                me.filtroStanza = { idPiano: me.idPiano, sesso: selectedSesso.codice };
            }
            me.sesso = me.filtroStanza.sesso;
        },
        //onChangeLetto(value) {
        //  let me = this;
        //  let selectedLetto = me.lettoOptions.find((letto) => letto.nome === value);
        //  if (selectedLetto) {
        //      me.filtroLetto = { idPiano: me.idPiano, sesso: me.sesso, idStanza: me.idStanza };
        //  }
        //  me.nomeLetto = me.filtroLetto.nome;
        //},

        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;

            switch (me.activeTabIndex) {
                case 0:
                    sessionStorage["filtroGestioneCamere"] = JSON.stringify(me.filtroGestioneCamere);
                    me.onChangeTab(me.activeTabIndex);
                    break;
                case 1:
                    me.filtroGestioneCamereStorico = { nomeStanza: me.filtroGestioneCamere.nomeStanza, nomePiano: me.filtroGestioneCamere.nomePiano, codiceSesso: me.filtroGestioneCamere.codiceSesso, stato: me.filtroGestioneCamere.statoAttuale, nome: me.filtroGestioneCamere.nome };
                    sessionStorage["filtroGestioneCamere"] = JSON.stringify(me.filtroGestioneCamereStorico);
                    me.onChangeTab(me.activeTabIndex);
                    break;
            }
        },
        onReset() {
            let me = this;
            me.filtroGestioneCamere = { idPresidio: me.idPresidio, nomePiano: null, nomeStanza: null, nome: null, codiceSesso: null, statoAttuale: null, idPiano: null };
            me.idPiano = null;
            me.sesso = null;
            me.stanzeOptions = [];
            me.lettoOptions = [];
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroGestioneCamere"] = JSON.stringify(me.filtroGestioneCamere);
            me.filtroPiano = {};
            if (me.idPresidio) {
                me.onChangePresidi(me.idPresidio);
            }
            me.loadDataPresidi();
            me.loadDataPiani();
            me.onChangeTab(me.activeTabIndex);
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onChangeTab(index) {
            let me = this;
            let indexTab = me.$refs.tabsGestioneCamere.getTabs()[index];
            me.activeTab(indexTab.id);
        },
        activeTab(idIndexTab) {
            let me = this;
            let path = "";
            let sessionStorage = window.sessionStorage;

            switch (idIndexTab) {
                case "gestioneCamere":
                    path = "/rsapostilettoletti";
                    sessionStorage["filtroGestioneCamere"] = JSON.stringify(me.filtroGestioneCamere);

                    me.$refs.cmpGestioneCamereList.setParametri(path);
                    break;
                case "storicoLetti":
                    path = "/rsapostilettolettostatistorico";
                    me.filtroGestioneCamereStorico = { nomeStanza: me.filtroGestioneCamere.nomeStanza, nomePiano: me.filtroGestioneCamere.nomePiano, codiceSesso: me.filtroGestioneCamere.codiceSesso, stato: me.filtroGestioneCamere.statoAttuale, nome: me.filtroGestioneCamere.nome };
                    sessionStorage["filtroGestioneCamere"] = JSON.stringify(me.filtroGestioneCamereStorico);

                    me.$refs.cmpGestioneStoricoList.setParametri(path);
                    break;
                default:
                    path = "/rsapostilettoletti";
                    sessionStorage["filtroGestioneCamere"] = JSON.stringify(me.filtroGestioneCamere);
                    me.$refs.cmpGestioneCamereList.setParametri(path);
                    break;
            }
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        loadDataPresidi() {
            let me = this;

            UtilityMixin.methods.loadDataResources(me.pathResourcePresidi, {}, me.loadDataPresidiSuccess, me.loadDataPresidiError);
        },
        loadDataPresidiSuccess(response) {
            let me = this;
            me.presidioOptions = [];
            // if (response.data.data.list) {
            //  me.presidioOptions = response.data.data.list.map((presidio) => ({ value: presidio.id, text: presidio.denominazione }));
            response.data.data.list.forEach((element) => {
                me.presidioOptions.push({ value: element.id, text: element.denominazione });
            });
            /*    } else {
                me.presidioOptions = [];
            } */
            me.presidioOptions.unshift({ value: null, text: "- Seleziona Presidio -" });
        },
        loadDataPresidiError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei presidi", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onChangePresidi(value) {
            let me = this;
            //me.filtroGestioneCamere.idPresidio = value;
            me.filtroPiano = { idPresidio: value };
            me.filtroStanza.idPresidio = value;
            me.filtroGestioneCamere.nomePiano = null;
            me.filtroGestioneCamere.nomeStanza = null;
            me.loadDataPiani();
            me.loadDataStanze();
        },
        onClickRendiDisponibiliLetti() {
            this.$refs.cmpGestioneCamereList.rendiDisponibiliLetti();
        },
    },
};
</script>
